import { Typography } from 'antd';
import { FC } from 'react';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  pageFetchState: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['pageFetchState'] | null
}

export const PageFetchStateLabel: FC<Props> = ({ pageFetchState }) => {
  if (pageFetchState) {
    if (pageFetchState === 'ACCESS_DENIED') {
      return <span>Заблоковано через несанкціонований запит (401)</span>;
    }
    if (pageFetchState === 'ACCESS_FORBIDDEN') {
      return <span>Заблоковано через заборону доступу (403)</span>;
    }
    if (pageFetchState === 'BLOCKED_4XX') {
      return <span>Заблоковано через іншу проблему 4xx (не 403, 404)</span>;
    }
    if (pageFetchState === 'BLOCKED_ROBOTS_TXT') {
      return <span>Заблоковано <strong>robots.txt</strong></span>;
    }
    if (pageFetchState === 'INTERNAL_CRAWL_ERROR') {
      return <span>Внутрішня помилка</span>;
    }
    if (pageFetchState === 'INVALID_URL') {
      return <span>Неправильна URL-адреса</span>;
    }
    if (pageFetchState === 'NOT_FOUND') {
      return <span>Не знайдено (404)</span>;
    }
    if (pageFetchState === 'PAGE_FETCH_STATE_UNSPECIFIED') {
      return <span>Невідомо</span>;
    }
    if (pageFetchState === 'REDIRECT_ERROR') {
      return <span>Помилка перенаправлення</span>;
    }
    if (pageFetchState === 'SERVER_ERROR') {
      return <span>Помилка сервера (5xx)</span>;
    }
    if (pageFetchState === 'SOFT_404') {
      return <span>Soft 404</span>;
    }
    if (pageFetchState === 'SUCCESSFUL') {
      return <span>Успішно</span>;
    }
  } else {
    return <Typography.Text>(недоступно)</Typography.Text>;
  }
};
